// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"559d288a","952":"fdc839bb"}[chunkId] + ".chunk.js";
};